export class Activity {
    constructor(data) {
      this.id = data.id;
      this.date = data.date;
      this.user_data = data.user_data;
      this.description = data.description;
    }
  }
  